// Contexto para anmazenar dados do ID do AutoComplete escolhido

import React, { createContext, useState } from "react";

export const TipoPagtoProfIdContext = createContext()
export const TipoPagtoProfDescrContext = createContext()

export const TipoPagtoProfContextProvider = ({ children }) => {
    const [tipoPagtoProfIdContext, setTipoPagtoProfIdContext] = useState('')
    const [tipoPagtoProfDescrContext, setTipoPagtoProfDescrContext] = useState('')

    return (
        <TipoPagtoProfIdContext.Provider value={{ tipoPagtoProfIdContext, setTipoPagtoProfIdContext }}>
            <TipoPagtoProfDescrContext.Provider value={{ tipoPagtoProfDescrContext, setTipoPagtoProfDescrContext }}>
                {children}
            </TipoPagtoProfDescrContext.Provider>
        </TipoPagtoProfIdContext.Provider>
    )
}